<wr-new-data-table headerText="Archiv"
                   localStorageIdentifier="attachmentStorageUse"
                   [loadItemsFunction]="loadAttachments"
                   [getCountFunction]="getCount"
                   [defaultPageSize]="5"
                   [form]="form">
  <ng-template dataTableFilter>
    <form [formGroup]="form">
      <div class="filter-form">
        <div class="filter-control-group">
          <label class="label" for="text">Textfilter</label>
          <input type="text" nbInput id="text" formControlName="text" placeholder="Filter Text...">
        </div>
        <div class="filter-control-group">
          <label class="label" for="datePicker">Zeitraum</label>
          <wr-date-range-picker id="datePicker" formControlName="selectedRange" [showTodayButton]="true"></wr-date-range-picker>
        </div>
        @if (isInternalTenant()) {
          <div class="filter-control-group">
            <label class="label" for="tenant">Kunden</label>
            <wr-tenant-select id="tenant"
                              formControlName="tenantId"
                              [tenantType]="TenantTypeEnum.External"
                              [showEmptyOption]="true">
            </wr-tenant-select>
          </div>
        }
        <div class="filter-control-group">
          <label class="label" for="building">Gebäude</label>
          <wr-building-select class="building"
                              id="building"
                              formControlName="building"
                              [tenantId]="currentTenantId()">
          </wr-building-select>
        </div>
        <div class="filter-control-group">
          <label class="label" for="tag">Tags</label>
          <wr-tag-select id="tag" formControlName="tag" [tenantId]="currentTenantId()"></wr-tag-select>
        </div>
        <div class="filter-control-group">
          <label class="label" for="isArchive">Im Archiv?</label>
          <nb-toggle id="isArchive" formControlName="isArchive" class="is-archive"></nb-toggle>
        </div>
      </div>
    </form>
  </ng-template>
  <ng-template
    dataColumn
    let-attachment
    key="preview"
    display="Datei"
    [sortable]="false"
    [exportable]="false">
    <wr-attachment-preview
      class="attachment-preview"
      size="small"
      [isDisabled]="true"
      [attachment]="attachment"
      >
    </wr-attachment-preview>
  </ng-template>
  <ng-template
    dataColumn
    let-attachment
    key="name"
    display="Dateiname"
    [sortable]="false"
    [exportValue]="exportFileName">
    @if (attachment.fileName && attachment.fileEnding) {
      <div>
        {{attachment.fileName}}.{{attachment.fileEnding}}
      </div>
    }
  </ng-template>
  <ng-template
    dataColumn
    let-attachment
    key="comment"
    display="Kommentar"
    [sortable]="false">
    @if (attachment.comment) {
      <div>
        {{attachment.comment}}
      </div>
    }
  </ng-template>
  <ng-template
    dataColumn
    let-attachment
    key="tags"
    display="Tags"
    [sortable]="false"
    [exportValue]="exportTags">
    @if (attachment.tags) {
      <div>
        <wr-tag-list [tags]="attachment.tags"></wr-tag-list>
      </div>
    }
  </ng-template>
  <ng-template
    dataColumn
    let-attachment
    key="created"
    display="Erstellungsdatum"
    [sortable]="false">
    @if (attachment.created) {
      <div>
        {{ attachment.created | date: 'dd.MM.yyyy' }}
      </div>
    }
  </ng-template>
  <ng-template
    dataColumn
    let-attachment
    key="inspection"
    display="Rundgang"
    [sortable]="false"
    [exportable]="false">
    @if (attachment.inspectionId) {
      <div>
        <button nbButton
                status="primary"
                [routerLink]="getInspectionLink(attachment)">
          <nb-icon pack="fas" icon="arrow-right"></nb-icon>
        </button>
      </div>
    }
  </ng-template>
</wr-new-data-table>
